import React, { useEffect } from 'react';
import {
	Modal,
	ModalHeader,
	ModalBody,
	Row,
	Col,
	Card,
	CardHeader,
	CardBody,
	ModalFooter,
	CardFooter,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import OPrint from '../../../Components/General/Widgets/OPrint';

import logoSped from '../../../assets/images/logo-sped.png';

const PaymentDetail = ({ dataPayment, isOpen, toggle }) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={toggle}
			size='lg'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={toggle}></ModalHeader>
			<ModalBody className='mb-0 pb-0'>
				<Row className='justify-content-center'>
					<Col xxl={12}>
						<Card id='print-payment'>
							<Row>
								<Col lg={12}>
									<CardHeader className='border-bottom-dashed p-4'>
										<div className='d-flex'>
											<div className='flex-grow-1'>
												<img
													src={logoSped}
													className='card-logo card-logo-dark'
													alt='logo dark'
													height='35'
												/>
											</div>
											<div className='flex-shrink-0 mt-sm-0 mt-3'>
												<h6>
													<span className='text-muted text-uppercase fw-semibold'>
														Servicios Informáticos Openlink SpA
													</span>
												</h6>
												<h6>
													<span className='text-muted fw-normal'>
														Dirección:
													</span>
													<span>
														{' '}
														Los Algarrobos 4997, Puerto Montt
													</span>
												</h6>
												<h6>
													<span className='text-muted fw-normal'>
														Celular:
													</span>
													<span> +569 4102 1383</span>
												</h6>
												<h6>
													<span className='text-muted fw-normal'>
														Correo:
													</span>
													<span> daniel@openlink.com</span>
												</h6>
											</div>
										</div>
									</CardHeader>
								</Col>
								<Col lg={12}>
									<CardBody className='p-4'>
										<Row className='g-3'>
											<Col lg={3} className='col-6'>
												<p className='text-muted mb-2 text-uppercase fw-semibold fs-13'>
													Nro Documento
												</p>
												<h5 className='fs-15 mb-0'>
													#{dataPayment?.code}
												</h5>
											</Col>
											<Col lg={3} className='col-6'>
												<p className='text-muted mb-2 text-uppercase fw-semibold fs-13'>
													Período
												</p>
												<h5 className='fs-15 mb-0'>
													{dataPayment?.description}
												</h5>
											</Col>

											<Col lg={3} className='col-6'>
												<p className='text-muted mb-2 text-uppercase fw-semibold fs-13'>
													Estado
												</p>
												<span
													className='badge fs-12 text-uppercase'
													id='payment-status'
													style={{
														backgroundColor:
															dataPayment?.payment_status
																?.bgcolor,
														color: dataPayment?.payment_status
															?.txcolor,
													}}
												>
													{dataPayment?.payment_status?.name}
												</span>
											</Col>

											<Col lg={3} className='col-6'>
												<p className='text-muted mb-2 text-uppercase fw-semibold fs-13'>
													Monto Total
												</p>
												<h5 className='fs-15 mb-0'>
													<span id='total-amount'>
														{dataPayment?.total_amount}{' '}
														{dataPayment?.currency}
													</span>
												</h5>
											</Col>
										</Row>
									</CardBody>
								</Col>
								<Col lg={12}>
									<CardBody className='p-4 border-top border-top-dashed'>
										<Row className='g-3'>
											<Col className='col-12'>
												<h6 className='text-muted text-uppercase fw-semibold fs-13 m-0 p-0'>
													Facturado a:
												</h6>
											</Col>
											<Col className='col-6'>
												<h6>
													<span className='text-muted fw-normal'>
														Nombre:
													</span>
													<span>
														{' '}
														{dataPayment?.company?.name}
													</span>
												</h6>
												<h6>
													<span className='text-muted fw-normal'>
														Rut:
													</span>
													<span> {dataPayment?.company?.rut}</span>
												</h6>
												<h6>
													<span className='text-muted fw-normal'>
														Dirección:
													</span>
													<span>
														{' '}
														{dataPayment?.company?.address}
													</span>
												</h6>
											</Col>

											<Col className='col-6'>
												<h6>
													<span className='text-muted fw-normal'>
														Celular:
													</span>
													<span>
														{' '}
														{dataPayment?.company?.phono}
													</span>
												</h6>
												<h6>
													<span className='text-muted fw-normal'>
														Correo:
													</span>
													<span>
														{' '}
														{dataPayment?.company?.email}
													</span>
												</h6>
											</Col>
										</Row>
									</CardBody>
								</Col>
								<Col lg={12}>
									<CardBody className='p-2 text-card-print'>
										<div className='table-responsive'>
											<table className='table table-borderless text-center table-nowrap align-middle mb-0'>
												<thead>
													<tr className='table-active'>
														<th
															scope='col'
															style={{ width: '50px' }}
														>
															#
														</th>
														<th scope='col'>Detalle</th>
														<th scope='col'>Modulos</th>
														<th scope='col' className='text-end'>
															Total
														</th>
													</tr>
												</thead>
												<tbody id='products-list'>
													{dataPayment?.items?.map(
														(row, index) => (
															<tr key={index}>
																<th scope='row p-0'>
																	{String(index + 1).padStart(
																		2,
																		'0'
																	)}
																</th>
																<td className='text-start p-0'>
																	<span className='fw-semibold text-uppercase'>
																		{row.establishment}
																	</span>
																	<p className='text-muted mb-0'>
																		{row.description}
																	</p>
																</td>
																<td>{row.quantity}</td>
																<td className='text-end pr-2'>
																	{row.total_price}{' '}
																	{dataPayment?.currency}
																</td>
															</tr>
														)
													)}
												</tbody>
											</table>
										</div>
										<div className='border-top border-top-dashed mt-2'>
											<table
												className='table table-borderless table-nowrap align-middle mb-0 ms-auto'
												style={{ width: '250px' }}
											>
												<tbody>
													<tr>
														<td>Sub Total</td>
														<td className='text-end'>
															{dataPayment?.net_amount}{' '}
															{dataPayment?.currency}
														</td>
													</tr>
													<tr>
														<td>I.V.A. (19%)</td>
														<td className='text-end'>
															{dataPayment?.tax_amount}{' '}
															{dataPayment?.currency}
														</td>
													</tr>
													{dataPayment?.discount_amount > 0 && (
														<tr>
															<td>
																Descuento{' '}
																<small className='text-muted'>
																	(10%)
																</small>
															</td>
															<td className='text-end'>
																- {dataPayment?.discount_amount}{' '}
																{dataPayment?.currency}
															</td>
														</tr>
													)}
													<tr className='border-top border-top-dashed fs-15'>
														<th scope='row'>Monto Total</th>
														<th className='text-end'>
															{dataPayment?.total_amount}{' '}
															{dataPayment?.currency}
														</th>
													</tr>
												</tbody>
											</table>
										</div>
									</CardBody>
									{/* <CardFooter className="no-print">
                    <div className="mt-4">
                      <div className="alert alert-info">
                        <p className="mb-0"><span className="fw-semibold">NOTA:</span>
                          <span id="note"> Todas las cuentas deben pagarse dentro de los 7 días posteriores a la recepción de la factura. El pago se realizará con cheque o tarjeta de crédito o mediante pago directo en línea. Si la cuenta no se paga dentro de los 7 días, se cobrará la tarifa acordada que se indica más arriba a los detalles de los créditos proporcionados como confirmación del trabajo realizado.
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="hstack gap-2 justify-content-end d-print-none mt-4">
                      <Link onClick={printPayment} to="#" className="btn btn-success"><i className="icon-printer align-bottom me-1"></i> Imprimir</Link>
                    </div>
                  </CardFooter> */}
								</Col>
							</Row>
						</Card>
						<OPrint referenceId={'print-payment'}></OPrint>
					</Col>
				</Row>
			</ModalBody>
		</Modal>
	);
};

export default PaymentDetail;
